import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './assets/styles/index.less'


//渲染App到页面
import {
    createRoot
} from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);

root.render( <App/> );

// ReactDOM.render(<App/>, document.getElementById('root'));